import { motion } from "framer-motion";
import { MapPin, MessageCircle } from "lucide-react";
import MapView from "./MapView";
import { WHATSAPP_URL } from "./constants";

const POINTS = [
  { name: "Fortaleza", detail: "Sede e atendimento principal", main: true },
  { name: "Caucaia", detail: "Região Metropolitana" },
  { name: "Maracanaú", detail: "Região Metropolitana" },
  { name: "Aquiraz", detail: "Região Metropolitana" },
  { name: "Eusébio", detail: "Região Metropolitana" },
  { name: "Itaitinga", detail: "Região Metropolitana" },
];

export default function Coverage() {
  return (
    <section id="atuacao" className="relative py-24 lg:py-32 carto-grid">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid gap-14 lg:grid-cols-[1.15fr_1fr] lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-2xl overflow-hidden border border-white/10 shadow-[0_24px_70px_rgba(0,10,30,0.65)]"
        >
          <MapView />
        </motion.div>

        <div>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.6 }}
            className="font-mono text-xs uppercase tracking-[0.32em] text-dm-contour"
          >
            Área de Atuação
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ delay: 0.1, duration: 0.7 }}
            className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white"
          >
            Fortaleza e <span className="text-gradient">região metropolitana</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.7 }}
            className="mt-5 text-base leading-relaxed text-slate-300"
          >
            Atendemos obras, imóveis rurais e empreendimentos em toda a região —
            toque nos pontos do mapa para conhecer cada localidade.
          </motion.p>

          <motion.ul
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: 0.3, duration: 0.7 }}
            className="mt-8 grid grid-cols-2 gap-3"
          >
            {POINTS.map((p, i) => (
              <li
                key={p.name}
                data-testid={`coverage-point-${i + 1}`}
                className="flex items-center gap-3 rounded-xl glass px-4 py-3.5"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-dm-blue/20 border border-dm-glow/25 text-dm-glow">
                  <MapPin size={14} />
                </span>
                <span>
                  <span className="block text-sm font-medium text-slate-100">{p.name}</span>
                  <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-slate-500">
                    {p.detail}
                  </span>
                </span>
              </li>
            ))}
          </motion.ul>

          <motion.a
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: 0.4, duration: 0.7 }}
            data-testid="coverage-whatsapp-button"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-3 rounded-full border border-[#25D366]/50 bg-[#25D366]/10 hover:bg-[#25D366]/20 text-[#25D366] font-semibold px-7 py-3.5 transition-all hover:-translate-y-0.5"
          >
            <MessageCircle size={18} />
            Consultar atendimento na sua região
          </motion.a>
        </div>
      </div>
    </section>
  );
}
